import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import DashAction from './DashAction';
import DashDeadline from './DashDeadline';
import type { AnalyticsDashDeadline } from '../model';

interface DashTermProps {
    deadline: AnalyticsDashDeadline;
}

const DashTerm = ({ deadline }: DashTermProps) => {
    const { t } = useTranslation(['Objects', 'common']);

    return (
        <div
            className={`object-analytics-dash__term${deadline.disabled ? ' is-disabled' : ''}`}
            aria-disabled={deadline.disabled || undefined}
        >
            <div className="object-analytics-dash__tile-head">
                <span className="object-analytics-dash__tile-label object-analytics-dash__label-with-icon text-muted">
                    <SolarIcon name="calendar3" aria-hidden="true" />
                    {t('toolDeadline')}
                </span>
                {!deadline.disabled && deadline.canChange ? (
                    <DashAction label={t('common:buttons.change')} onClick={deadline.onChange} />
                ) : null}
            </div>
            {deadline.disabled ? (
                <span className="object-analytics-dash__deadline-date text-muted">—</span>
            ) : (
                <DashDeadline
                    dateStart={deadline.dateStart}
                    dateEnd={deadline.dateEnd}
                    taskStatus={deadline.taskStatus}
                />
            )}
        </div>
    );
};

export default DashTerm;
